function getSessionId(): string {
  const key = 'vv_sid';
  let sid = sessionStorage.getItem(key);
  if (!sid) {
    sid = Math.random().toString(36).slice(2) + Date.now().toString(36);
    sessionStorage.setItem(key, sid);
  }
  return sid;
}

export function logToB3d(path: string): void {
  const b3dUrl = import.meta.env.VITE_B3D_LOG_URL;
  if (!b3dUrl) return;

  const payload = {
    source: 'vivi',
    pathname: path,
    referrer: document.referrer || '',
    sessionId: getSessionId(),
    screen: `${window.screen.width}x${window.screen.height}`,
  };

  fetch(b3dUrl, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
    keepalive: true,
  }).catch(() => {});
}
